"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractContentInfoFromUrl = void 0;
const siteContentRules_1 = require("./siteContentRules");
const extractContentInfoFromUrl = (inputUrl) => {
    const url = new URL(inputUrl);
    for (const instructions of Object.values(siteContentRules_1.siteContentRules).sort((a, b) => a.weight - b.weight)) {
        const subjectDomain = url.hostname.replace('www.', '');
        if (typeof instructions.domain === 'string') {
            if (subjectDomain !== instructions.domain) {
                continue;
            }
        }
        else if (!instructions.domain.test(subjectDomain)) {
            continue;
        }
        const attributes = instructions.extractContentInfo(url, new URLSearchParams(url.search));
        if (!attributes) {
            continue;
        }
        return {
            contentType: instructions.contentType,
            site: instructions.site,
            urlVariant: instructions.urlVariant,
            ...attributes,
        };
    }
    return null;
};
exports.extractContentInfoFromUrl = extractContentInfoFromUrl;
//# sourceMappingURL=extractContentInfoFromUrl.js.map